import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { isNullOrUndefined } from '../objectUtils';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommonDataService {

  private loadedDomains: models.DomainVM[];
  constructor(private http: HttpClient, private translate: TranslateService) {
    if (isNullOrUndefined(this.loadedDomains))
      this.loadedDomains = <models.DomainVM[]>[];
  }

  public getDomain(domainCode: string) {
    return this.http.get<models.DomainVM>("api/CommonData/GetDomain", { params: { language: this.translate.currentLang, domain: domainCode } });
  }

  private getDomainsRequest(domainCodes: string[]) {
    return this.http.get<models.DomainVM[]>("api/CommonData/GetDomains", { params: { language: this.translate.currentLang, domains: domainCodes } });
  }
  private setLoadedDomains(newDomains: models.DomainVM[]) {
    this.loadedDomains = [...new Set(this.loadedDomains.concat(newDomains))];
  }

  public getDomains(domainCodes: string[]) {
    var stringLoadedDomains = _.remove(domainCodes, x => this.loadedDomains.some(ld => ld.domainCode == x));
    var existingDimensions = _.filter(this.loadedDomains, x => stringLoadedDomains.some(ld => ld == x.domainCode));
    if (domainCodes.length <= 0)
      return of(existingDimensions);
    else {
      return this.getDomainsRequest(domainCodes).pipe(map((result: models.DomainVM[]) => {
        var test = result.concat(existingDimensions);
        this.setLoadedDomains(result);
        return test;
      }));
    }
  }
}
